export default {
  namespaced: true,
  state: () => ({
    isInitiatedByChat: false,
    isScanCompleted: false,
  }),
  mutations: {
    setIsInitiatedByChat(state, value) {
      state.isInitiatedByChat = value;
    },
    setIsScanCompleted(state, value) {
      state.isScanCompleted = value;
    },
  },
};
